'use strict';

export default class Shuffle {

    constructor (array) {
      this.array = array
      this.counter = array.length;
    }

    createRandomArray () {
      // While there are elements in the array
      while (this.counter > 0) {
          // Pick a random index
          let index = Math.floor(Math.random() * this.counter);

          // Decrease counter by 1
          this.counter--;

          // And swap the last element with it
          let temp = this.array[this.counter];
          this.array[this.counter] = this.array[index];
          this.array[index] = temp;
      }

      return this.array;
    }
}
